

















import Vue from 'vue'
import { computed, defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'VPuzzle',

  props: {
    pieces: {
      type: Array,
      required: true
    }
  },

  setup() {
    const order = ref([5, 1, 3, 2, 6, 4])
    const correct = computed(() => {
      return JSON.stringify(order.value) === JSON.stringify([1, 2, 3, 4, 5, 6])
    })

    const checkedFirstIndex = ref<number | null>(null)
    const checkedSecondIndex = ref<number | null>(null)

    const togglePiece = (pieceIndex: number) => {
      if (checkedFirstIndex.value === null) {
        checkedFirstIndex.value = pieceIndex
      } else {
        checkedSecondIndex.value = pieceIndex
        let tempArray = [...order.value]
        tempArray[checkedFirstIndex.value] =
          order.value[checkedSecondIndex.value]
        tempArray[checkedSecondIndex.value] =
          order.value[checkedFirstIndex.value]
        order.value = [...tempArray]
        checkedFirstIndex.value = null
        checkedSecondIndex.value = null
      }
    }

    return {
      order,
      correct,
      checkedFirstIndex,
      checkedSecondIndex,
      togglePiece
    }
  }
})
